import { openModal, closeModal } from '../lib/modal.js';
import { ARCHIVE_PASSWORD } from '../state.js';

// Replaces window.prompt() for the archive password gate — prompt() is unreliable in iOS
// standalone mode, same class of bug as confirm(). Guards any archive-modifying action;
// runs cb() only on a correct password.
let _passwordDialogCallback = null;

export function requirePassword(promptText, cb) {
  document.getElementById('passwordDialogTitle').textContent = promptText;
  const inp = document.getElementById('passwordDialogInp');
  inp.value = '';
  inp.style.borderColor = '';
  _passwordDialogCallback = cb;
  openModal('shPasswordDialog');
  setTimeout(() => inp.focus(), 200);
}

export function requireArchivePassword(cb) {
  requirePassword('Введи пароль для изменения архива:', cb);
}

export function confirmPasswordDialog() {
  const inp = document.getElementById('passwordDialogInp');
  if (inp.value !== ARCHIVE_PASSWORD) {
    inp.style.borderColor = 'var(--red)';
    inp.value = '';
    inp.placeholder = 'Неверный пароль';
    return;
  }
  const cb = _passwordDialogCallback;
  _passwordDialogCallback = null;
  closeModal('shPasswordDialog');
  if (cb) cb();
}
